
import axios from 'axios';
import {axiosFailInterceptor, axiosSuccessInterceptor} from "@router";

/**
 * A Helper to get data from CMS using a non-authenticated instance of axios.
 */
export const getFromCms = async (url, params = {}) => {
    const instance = axios.create();

    return instance.get(url,{params, transformRequest: (data, headers) => {
            delete headers['x-dietitian-token'];
            delete headers['x-access-token'];
            delete headers['x-passcode-token'];
        }})
}

const axiosInstance = axios.create({ baseURL: process.env.VUE_APP_API });

axiosInstance.interceptors.response.use(
    (res) => axiosSuccessInterceptor(res),
    (fail) => axiosFailInterceptor(fail)
);

// Dev builds only: open any page with ?apiDelay=2000 to hold every API call back that long for the rest of the tab's
// session, to look at loading states. ?apiDelay=0 turns it off. Covers $axios and the bare axios the store modules use.
if (process.env.NODE_ENV === 'development') {
    const apiDelay = new URLSearchParams(window.location.search).get('apiDelay');
    if (apiDelay !== null) sessionStorage.setItem('apiDelay', apiDelay);

    const delayRequest = async (config) => {
        const delay = Number(sessionStorage.getItem('apiDelay')) || 0;
        if (delay > 0) await new Promise(resolve => setTimeout(resolve, delay));
        return config;
    };
    [axiosInstance, axios].forEach(instance => instance.interceptors.request.use(delayRequest));
}

export const getCoreAxiosInstance = () => {
    return axiosInstance;
}
